import { PiArrowRight, PiPhoneCall, PiVideoCamera } from "react-icons/pi";
import { Button } from "@/components/ui/Button";
import { Link } from "react-router-dom";
import {
  AssetFrontendVoiceCallsApi,
  PublicAssetFrontendApi$AssetComponentDto,
  PublicAssetFrontendApi$AssetComponentDtoKey,
  AssetFrontendVoiceCallsApi$InfoState,
} from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import useUiContext from "@/custolink-hooks/useUiContext";
import { useTranslation } from "react-i18next";

export default function BottomSection(p: {
  components: Array<PublicAssetFrontendApi$AssetComponentDto>;
  selectComponent: (
    component: PublicAssetFrontendApi$AssetComponentDto,
  ) => void;
}) {
  const {t} = useTranslation()
  const vid = p.components.find(
    (s) => s.key == PublicAssetFrontendApi$AssetComponentDtoKey.VideoCall,
  );
  const voicecall = p.components.find(
    (s) => s.key == PublicAssetFrontendApi$AssetComponentDtoKey.VoiceCall,
  );
  return (
    <div className="grid grid-cols-1 gap-4">
      {vid != null && (
        <Link
          to={""}
          className={"bg-gray-100 rounded-2xl p-4 shadow-lg"}
          onClick={(ev) => {
            ev.preventDefault();
            p.selectComponent(vid);
          }}
        >
          <div className="flex flex-row space-x-4">
            <Button
              className={"bg-background-color-asset-frontend"}
              shape="circle"
              size="lg"
              variant={"default"}
              icon={<PiVideoCamera className={"text-2xl text-white"} />}
            />

            <div className={"flex-1 flex flex-col"}>
              <div className="text-xl">{vid.name}</div>
              <small className={"text-xs"}>{t('component.videocall.subtitlePrompt')}</small>
            </div>

            <div className={"flex-1 flex flex-col justify-center items-center"}>
              <PiArrowRight className={"text-2xl text-primary ml-auto"} />
            </div>
          </div>
        </Link>
      )}

      {voicecall != null && (
        /*
        <a
          href={"tel:" + p.voiceCallPhoneNumber}
          className={"bg-gray-100 rounded-2xl p-4 shadow-lg"}
        >
         */
        <VoiceCallWrapper component={voicecall} selectComponent={p.selectComponent} />
      )}
    </div>
  );
}

const VoiceCallWrapper = (p: {
  component: PublicAssetFrontendApi$AssetComponentDto;
  selectComponent: (
    component: PublicAssetFrontendApi$AssetComponentDto,
  ) => void;
}) => {

  const {t} = useTranslation()
  const vc = useVoiceCallPreHook(p.component);

  const content = useMemo(
    () => (
      <div className="flex flex-row space-x-4">
        <Button
          className={"bg-background-color-asset-frontend"}
          shape="circle"
          size="lg"
          variant={"default"}
          icon={<PiPhoneCall className={"text-2xl text-white"} />}
        />

        <div className={"flex-1 flex flex-col"}>
          <div className="text-xl">{p.component.name}</div>
          <small className={"text-xs"}>{t('component.voicecall.subtitlePrompt')}</small>
        </div>

        <div className={"flex-1 flex flex-col justify-center items-center"}>
          <PiArrowRight className={"text-2xl text-primary ml-auto"} />
        </div>
      </div>
    ),
    [p.component],
  );

  if (vc.mode == "show_text") {
    return (
      <Link
        to={""}
        className={"bg-gray-100 rounded-2xl p-4 shadow-lg"}
        onClick={(ev) => {
          ev.preventDefault();
          p.selectComponent(p.component);
        }}
      >
        {content}
      </Link>
    );
  } else if (vc.mode == "instant_call") {
    return (
      <a
        href={"tel:"+vc.phonenumber}
        className={"bg-gray-100 rounded-2xl p-4 shadow-lg"}
      >
        {content}
      </a>
    );
  } else {
    return <a
      href={"tel:"}
      className={"bg-gray-100 rounded-2xl p-4 shadow-lg"}
    >
      {content}
    </a>
  }
};

const useVoiceCallPreHook = (
  component: PublicAssetFrontendApi$AssetComponentDto,
) => {
  const [mode, setmode] = useState<"initial" | "instant_call" | "show_text">(
    "initial",
  );

  const uic = useUiContext();
  const req = useQuery({
    queryFn: () =>
      AssetFrontendVoiceCallsApi.getInfo(uic._orgId, component.id),
    queryKey: [
      "AssetFrontendVoiceCallsApi.getInfo",
      uic._orgId,
      component.id,
    ],
  });

  useEffect(() => {
    if (req.data != null) {
      if (
        req.data.state == AssetFrontendVoiceCallsApi$InfoState.CallPhoneNumber
      ) {
        setmode("instant_call");
      } else if (
        req.data.state == AssetFrontendVoiceCallsApi$InfoState.ShowText
      ) {
        setmode("show_text");
      }
    }
  }, [req.data]);

  return {
    mode: mode,
    phonenumber : req?.data?.phone ?? ""
  };
};
